import {TableObject} from 'common/objects/data_table'
import _ from 'lodash'

const table_sentinel = '__bee__table_sentinel'
function is_table(obj: unknown): obj is TableObject {
  return _.get(obj, [table_sentinel]) === true
}

export {table_sentinel, is_table}
